<template>
    <Section v-if="product && hasTickets" class="checkout-activity">
        <template #left>
            <ActivityForm :product="product" :sectionId="sectionId" />
        </template>
        <template #right>
            <ActivityDetails :product="product" />
        </template>
    </Section>
</template>

<script lang="ts">
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import Section from '@/components/checkoutPageV3/Shared/Section/Section.vue';
    import { useStore } from '@/store';
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent } from 'vue';
    import ActivityForm from './Form/Form.vue';
    import ActivityDetails from './Details/Details.vue';
    import { isEmpty } from 'lodash';

    export default defineComponent({
        name: 'Activity',
        methods: { t },
        components: { Section, ActivityForm, ActivityDetails },
        props: {
            sectionId: { type: String, required: true },
            productId: { type: String, required: true },
        },
        setup(props) {
            const store = useStore();

            const product = computed<ActivityProduct | undefined>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            const hasTickets = computed(
                () => product.value && !isEmpty(product.value?.Tickets)
            );

            return { product, hasTickets };
        },
    });
</script>

<style lang="scss">
    @forward 'Activity.scss';
</style>
